/* eslint-disable import/prefer-default-export */
import cloneDeep from 'lodash.clonedeep';
import {
  FormTemplate,
  FormTemplateSection,
} from 'data/template/template.types';
import {
  SecurityPolicy,
  SecurityPolicyAdaptedData,
  newSecurityPolicyAdaptedData,
} from 'data/securityPolicy/securityPolicy.types';
import setAllFieldsAsReadOnlyExcludingFields from 'shared/form/fields/setAllFieldsAsReadOnlyExcludingFields';
import { NO_CONSECUTIVE_CHARACTERS_LIMIT, MAX_CONSECUTIVE_CHARACTERS_DEFAULT } from 'routes/SecurityPolicy/securityPolicyConstants';

export type ListenersIpAddressPortsType = {
  [key: string]: string[],
}

export function adaptTemplateVisibilityMode(
  template: FormTemplate | undefined,
  mode: 'create' | 'edit' | 'view',
): FormTemplate | undefined {
  if (template == null) {
    return;
  }

  const clonedTemplate = cloneDeep(template);

  if (mode === 'view') {
    setAllFieldsAsReadOnlyExcludingFields(clonedTemplate, []);
  }

  return clonedTemplate;
}

export function adaptSecurityPolicyData(securityPolicyData: SecurityPolicy[]): SecurityPolicyAdaptedData {
  let adaptedData: SecurityPolicyAdaptedData = newSecurityPolicyAdaptedData;

  securityPolicyData.map((policy: SecurityPolicy) => {
    const fieldName: string = policy.name;
    let fieldValue: string = policy.value;

    if (fieldName === 'maxConsecutiveCharacters') {
      if (fieldValue !== NO_CONSECUTIVE_CHARACTERS_LIMIT && Number(fieldValue) <= MAX_CONSECUTIVE_CHARACTERS_DEFAULT) fieldValue = 'true'
      else fieldValue = 'false';
    }
    if (fieldName === 'allowNumericSequences'
      || fieldName === 'allowPasswordUsernameMatch'
      || fieldName === 'allowCurrentPasswordReuse'
    ) fieldValue = fieldValue === 'true' ? 'false' : 'true';

    adaptedData = {
      ...adaptedData,
      [fieldName]: fieldValue,
    }
  })

  return adaptedData;
}

export function adaptSecurityPolicyTemplate(
  template: FormTemplate | undefined,
  fieldName: string,
  fieldValue: string,
): FormTemplate | undefined {

  if (template == null) {
    return;
  }

  const clonedTemplate = cloneDeep(template);
  clonedTemplate.formId = Date.now().toString();

  if (fieldName === 'enableAccountLockout') {
    (clonedTemplate.accountLockoutSettings as FormTemplateSection).fields.maxAccountLoginAttempts.hide = fieldValue === 'true' ? 'false' : 'true';
    (clonedTemplate.accountLockoutSettings as FormTemplateSection).fields.accountLoginAttemptsIntervalMinutes.hide = fieldValue === 'true' ? 'false' : 'true';
    (clonedTemplate.accountLockoutSettings as FormTemplateSection).fields.accountLockDurationMinutes.hide = fieldValue === 'true' ? 'false' : 'true';
    (clonedTemplate.accountLockoutSettings as FormTemplateSection).fields.applyToSystemAdminAccount.hide = fieldValue === 'true' ? 'false' : 'true';
  } else if (fieldName === 'enableIpAddressBlocking') {
    (clonedTemplate.ipAddressBlockingSettings as FormTemplateSection).fields.maxIpAddressLoginAttempts.hide = fieldValue === 'true' ? 'false' : 'true';
    (clonedTemplate.ipAddressBlockingSettings as FormTemplateSection).fields.ipAddressLoginAttemptsIntervalMinutes.hide = fieldValue === 'true' ? 'false' : 'true';
    (clonedTemplate.ipAddressBlockingSettings as FormTemplateSection).fields.ipAddressBlockDurationMinutes.hide = fieldValue === 'true' ? 'false' : 'true';
  }

  return clonedTemplate;
}
